export type ProductDetailsHashSyncAction =
  | 'closeModal'
  | 'openModalFromFragment'
  | 'writeFragment'
  | 'dropFragment'
  | 'none';

export interface ProductDetailsFragment {
  kind: 'product' | 'kit';
  value?: string;
}

interface ResolveProductDetailsHashSyncActionParams {
  fragment?: ProductDetailsFragment;
  openedItem?: ProductDetailsFragment;
  lastSyncedEntity?: ProductDetailsFragment;
}

const isSameEntity = (oneEntity?: ProductDetailsFragment, otherEntity?: ProductDetailsFragment) =>
  oneEntity?.kind === otherEntity?.kind && oneEntity?.value === otherEntity?.value;

export const isProductDetailsInSyncWithFragment = ({
  fragment,
  openedItem,
}: ResolveProductDetailsHashSyncActionParams) => isSameEntity(fragment, openedItem);

export const resolveProductDetailsHashSyncAction = ({
  fragment,
  openedItem,
  lastSyncedEntity,
}: ResolveProductDetailsHashSyncActionParams): ProductDetailsHashSyncAction => {
  if (isSameEntity(fragment, openedItem)) {
    return 'none';
  }

  if (!isSameEntity(fragment, lastSyncedEntity)) {
    return fragment?.value ? 'openModalFromFragment' : 'closeModal';
  }

  return openedItem?.value ? 'writeFragment' : 'dropFragment';
};

interface ResolveFragmentParams {
  isProductFragmentOpen: boolean;
  productFragmentValue?: string;
  isKitFragmentOpen: boolean;
  kitFragmentValue?: string;
}

export const resolveFragment = ({
  isProductFragmentOpen,
  productFragmentValue,
  isKitFragmentOpen,
  kitFragmentValue,
}: ResolveFragmentParams): ProductDetailsFragment | undefined => {
  if (isKitFragmentOpen) {
    return { kind: 'kit', value: kitFragmentValue };
  }

  if (isProductFragmentOpen) {
    return { kind: 'product', value: productFragmentValue };
  }
};

interface ResolveOpenedItemParams {
  isModalOpen: boolean;
  openedProductColorId?: string;
  openedKitId?: string;
}

export const resolveOpenedItem = ({
  isModalOpen,
  openedProductColorId,
  openedKitId,
}: ResolveOpenedItemParams): ProductDetailsFragment | undefined => {
  if (!isModalOpen) {
    return;
  }

  if (openedKitId) {
    return { kind: 'kit', value: openedKitId };
  }

  if (openedProductColorId) {
    return { kind: 'product', value: openedProductColorId };
  }
};
